import React from 'react';
import { IonToast } from '@ionic/react';
import { map, reject } from 'lodash/fp';
import { useAtom } from 'jotai';
import { toastsAtom } from '../utils/Global';

const Toast: React.FC = () => {
    const [toasts, setToasts] = useAtom(toastsAtom);

    const removeToast = (uuid: string) => {
        setToasts(reject({ uuid }, toasts));
    };

    return (
        <>
            {map(
                ({ uuid, ...option }: any) => (
                    <IonToast
                        key={uuid}
                        isOpen
                        {...option}
                        buttons={[
                            {
                                text: 'X',
                                role: 'cancel',
                            },
                        ]}
                        onDidDismiss={() => {
                            removeToast(uuid);
                        }}
                        position="top"
                    />
                ),
                toasts
            )}
        </>
    );
};

export default Toast;
